const { BASE_URL } = require("./client");

const POST_CAPITAL_OFFICE_DATA = BASE_URL + "/api/capitalofficeform";
const GET_CAPITAL_OFFICE_DATA = BASE_URL + "/api/capitalofficeform";

module.exports = {
  POST_CAPITAL_OFFICE_DATA,
  GET_CAPITAL_OFFICE_DATA,
};
